export class ProductMaterialCategory {
  static ApiUrl = 'api/product-material-categories';

  Id: number;
  Name: string;
  NameEn: string;
  NameEs: string;
}
